import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  const navItems = [
    { path: '/', label: 'HOME' },
    { path: '/about-us', label: 'ABOUT US' },
    { path: '/events', label: 'EVENTS' },
    { path: '/gallery', label: 'GALLERY' },
    { path: '/contact', label: 'CONTACT' },
  ]

   const handleRedirect = (redirectUrl:  any) => {
  window.open(redirectUrl, '_blank', 'noopener,noreferrer')
}

  return (
    <header className="bg-gradient-to-r from-white via-gray-50 to-gray-100 sticky top-0 z-50 shadow-lg border-b-2 border-primary-light/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="flex items-center bg-white rounded-lg p-2 shadow-md group-hover:shadow-lg transition-shadow duration-300">
              <img
                src={`${import.meta.env.BASE_URL}lmt-logo-new.png`}
                alt="LMT SEVA Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
            <div className="hidden sm:block">
              <div className="text-gray-900 font-bold text-lg group-hover:text-primary-light transition-colors duration-300">LMT SEVA</div>
              <div className="text-gray-600 text-xs">Ek Koshish, For Better Tomorrow</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 rounded-lg transition-colors duration-300 ${
                  isActive(item.path)
                    ? 'text-white font-semibold bg-primary-light shadow-md'
                    : 'text-gray-700 hover:text-primary-light hover:bg-primary-light/10 font-medium'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button className="bg-primary-light hover:bg-primary-dark text-white px-6 py-2 rounded-lg font-semibold transition-colors duration-300"  onClick={() => handleRedirect('https://www.ticketmaster.com/event/2D006375A9CAB6E2')}>
             Buy Tickets
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-primary-light"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-300">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'text-white bg-primary-light font-semibold shadow-md'
                      : 'text-gray-700 hover:text-primary-light hover:bg-primary-light/10 font-medium'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <button className="mx-4 mt-4 bg-primary-light hover:bg-primary-dark text-white px-6 py-2 rounded-lg font-semibold transition-colors shadow-md"  onClick={() => handleRedirect('https://www.ticketmaster.com/event/2D006375A9CAB6E2')}>
               Buy Tickets
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header

